(function () {
  const initialise = (root) => {
    if (!root || root.dataset.h2oSolutionsReady === 'true') return;

    const track = root.querySelector('[data-h2o-solutions-track]');
    const previous = root.querySelector('[data-h2o-solutions-prev]');
    const next = root.querySelector('[data-h2o-solutions-next]');
    const status = root.querySelector('[data-h2o-solutions-status]');
    const cards = Array.from(root.querySelectorAll('[data-h2o-solutions-card]'));

    if (!track || cards.length < 2 || !previous || !next) return;
    root.dataset.h2oSolutionsReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame;

    const cardStep = () => {
      const firstCard = cards[0];
      if (!firstCard) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return firstCard.getBoundingClientRect().width + gap;
    };

    const update = () => {
      frame = null;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;

      const step = cardStep();
      const current = Math.min(cards.length, Math.max(1, Math.round(track.scrollLeft / step) + 1));
      if (status) status.textContent = `Popular solution ${current} of ${cards.length}`;
    };

    const scheduleUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    const move = (direction) => {
      track.scrollBy({
        left: cardStep() * direction,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(track);
    }

    update();
  };

  const initialiseAll = (scope) => {
    scope.querySelectorAll('[data-h2o-solutions]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
